(function(){
  var tags = [],
      filteredProducts = [],
      endlessScroll = null;
  
  
  var moneyformat = window.theme.currency.moneyWithCurrencyFormat;
  

  function initSliders(){
    const swiperContainers = document.querySelectorAll('.tile-media-slider');

    swiperContainers.forEach(element => {
            const new_swiper = new Swiper(element, {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                preloadImages: false,
                lazy: true
            });

            const isNextEnabled = element.getAttribute('data-next-enabled') === 'true';
            // Add listener for mouse entering the container
            element.addEventListener('mouseenter', () => {
                if (isNextEnabled && new_swiper) {
                    new_swiper.slideNext();
                }
            });

            // Add listener for mouse leaving the container
            element.addEventListener('mouseleave', () => {
                // Return to the first slide
                if (isNextEnabled && new_swiper){
                    new_swiper.slideTo(0);
                }
            });
    });
  }



  document.addEventListener("DOMContentLoaded", function() {
    initSliders();

  });
  
})();

function imgUrl(src, size = '300x') {
  if (!src) return '';
  
  // split URL into [basename, extension]
  const parts = src.split('?'); // separate query string
  const baseUrl = parts[0];
  const query = parts[1] ? '?' + parts[1] : '';

  const lastDot = baseUrl.lastIndexOf('.');
  if (lastDot === -1) return src; // no extension

  const name = baseUrl.substring(0, lastDot);
  const ext = baseUrl.substring(lastDot);

  return `${name}_${size}${ext}${query}`;
}

class ColorSelectionStore {
  constructor() {
    this.items = [];
    this.cartPrice = {
      price: 0,
      compare: 0,
    };
    this.listeners = new Set();

    this._state = {
      maxItems : 0,
      freeItems : 0,
      optionalItems : 0,
      requiredOff : 0,
      optionalOff : 0,
    }
  }

    // --- General Getter ---
  get(prop) {
    return this._state[prop];
  }

  // --- General Setter (triggers notify) ---
  set(prop, value) {
    if (!(prop in this._state)) {
      throw new Error(`Property "${prop}" does not exist in store.`);
    }
    this._state[prop] = value;
    this._applyDiscounts();
    this._calculateCartPrice();
    this.notify();
  }

  getItems() {
    return this.items;
  }

  getCartPrice() {
    return this.cartPrice;
  }

  _applyDiscounts() {
    const { requiredOff } = this._state;

    this.items = this.items.map(item => {
      let compare = item.compare;
      let price   = compare - ((requiredOff * compare) / 100);
      return { ...item, price, compare };
    });
  }

  _calculateCartPrice() {
    // Simple example: sum of item.price
    const total = this.items.reduce((sum, item) => sum + (parseFloat(item.price) || 0), 0);

    // If you also want a “compare at” price, compute it here
    const compareTotal = this.items.reduce(
      (sum, item) => sum + (parseFloat(item.compare) || parseFloat(item.price) || 0),
      0
    );

    this.cartPrice = {price: total, compare: compareTotal};
  }

  subscribe(fn) {
    this.listeners.add(fn);
    // Call immediately with current state (optional, but useful)
    fn(this.items);
    // Return unsubscribe function
    return () => this.listeners.delete(fn);
  }

  notify() {
    this.listeners.forEach(fn => fn(this.items));
  }

  _addToCartHelper(formData){
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) =>response.json())
      .then((data) => {
        // console.log(data);
        const event = new CustomEvent('miniCart:itemAdded',{
          detail: null,
          bubbles: true
        })
        document.dispatchEvent(event)
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  addToCartNormal(id,quantity){
        let formData = {
          items: [
            {
              id,
              quantity
            },
          ],
        };

        this._addToCartHelper(formData);
  }

  addToCart(id,quantity){

    if (!id) {
      console.error("Parent product ID is required to add bundle to cart.");
      return;
    }
      // ✅ generate unique set id
    const uniqueSetId = Math.random().toString(36).substring(2, 10);

    // ✅ group items by id and count quantity
    const grouped = this.items.reduce((acc, item) => {
      if (!acc[item.id]) {
        acc[item.id] = { ...item, quantity: 0 };
      }
      acc[item.id].quantity += 1;
      return acc;
    }, {});

    // ✅ build child items json
    const childItemsJson = JSON.stringify(
      Object.values(grouped).map(i => ({
        id: i.id,
        quantity: i.quantity,
        customKey: i.price ?? 0, // fallback if no price
        img: i.img,
        title: i.name
      }))
    );

    // ✅ free variants (comma separated IDs)
    const freeVariants = this.items.map(i => i.id).join(",");

    let formData = {
      items: [
        {
          id: parseInt(id), // main bundle parent variant ID
          quantity: parseInt(quantity),
          properties: {
            "_bundle-parent": true,
            "_set": uniqueSetId,
            "_childItemsJson": childItemsJson,
            "_free_variants": freeVariants
          }
        },
      ],
    };

    this._addToCartHelper(formData);

  }

  add(item) {
    // ✅ enforce maxItems
    if (this._state.maxItems > 0 && this.items.length >= this._state.maxItems) {
      console.warn("Max items reached, cannot add more.");
      return;
    }
    this.items.push({...item});
    this._calculateCartPrice();
    this.notify();
  }

  removeOne(id) {
    const index = this.items.findIndex(i => i.id === id);
    if (index !== -1) {
      this.items.splice(index, 1);
      this._calculateCartPrice();
      this.notify();
    }
  }

  remove(id) {
    this.items = this.items.filter(i => i.id !== id);
    this._calculateCartPrice();
    this.notify();
  }

  count(id) {
    return this.items.filter(i => i.id === id).length;
  }

  trimTo(limit) {
    const n = Number(limit);
    if (!Number.isFinite(n) || n < 0) {
      console.warn("trimTo: invalid limit", limit);
      return;
    }

    if (this.items.length > n) {
      this.items = this.items.slice(0, n);
      this.notify();
    }
  }
}

/** Parse design count from variant option like "3 Designs" / "4 Desgins" (typo). */
function resolveBundleFreeItems(metafields, variant) {
  const fromMeta = Number(metafields?.free_items);
  if (Number.isFinite(fromMeta) && fromMeta > 0) {
    return { count: fromMeta, inferred: false };
  }

  const label = String(variant?.option1 || variant?.title || "");
  // Only treat Design-bundle options as counts — never "Einzelstück" or unrelated options
  const match = label.match(/^\s*(\d+)\s*Desig/i);
  if (match) {
    const parsed = Number(match[1]);
    if (Number.isFinite(parsed) && parsed > 0) {
      return { count: parsed, inferred: true };
    }
  }
  return { count: 0, inferred: false };
}

function resolveBundleDiscount(metafields, freeItems, inferredFromOption) {
  const fromMeta = Number(metafields?.discount_percentage);
  if (Number.isFinite(fromMeta) && fromMeta > 0) return fromMeta;

  // Only invent discounts when free_items itself was inferred (metafields missing)
  if (!inferredFromOption) return 0;

  const defaults = { 3: 15, 4: 20, 6: 25 };
  return defaults[freeItems] || 0;
}

window.ColorSelectionStore = new ColorSelectionStore();


class AutoVariantSelector {
  constructor(variantMetafields = {}, store) {
    this.variantMetafields = variantMetafields; // the map you defined
    this.store = store; // instance of ColorSelectionStore
    this.currentVariantId = null;
  }

  setVariantMetafields(variantMetafields) {
    this.variantMetafields = variantMetafields || {};
  }

  setVariant(variantId) {
    this.currentVariantId = variantId;
  }

  addItem(item) {
    const variantMeta = this.variantMetafields[this.currentVariantId] || {};
    const { count: freeLimit } = resolveBundleFreeItems(
      variantMeta,
      (window.productData?.variants || []).find(
        (v) => String(v.id) === String(this.currentVariantId)
      )
    );
    if (!freeLimit) {
      console.warn("No free_items for variant", this.currentVariantId);
      return;
    }

    const currentCount = this.store.getItems().length;

    // Case 1: still within free limit
    if (currentCount < freeLimit) {
      this.store.add(item);
      return;
    }

    // Case 2: exceeded limit → try to upgrade
    const nextVariantId = this.findNextVariant(freeLimit);
    if (nextVariantId) {
      this.currentVariantId = nextVariantId;
      this.store.add(item);

      // 🔥 Optionally trigger Shopify variant change event
      const event = new CustomEvent("variant:update:selection", {
        detail: { variantId: nextVariantId },
        bubbles: true,
        composed: true
      });
      document.dispatchEvent(event);
    } else {
      // Case 3: no upgrade available → stop selection
      console.warn("Reached max allowed items. Cannot add more.");
    }
  }

  findNextVariant(currentFreeLimit) {
    let next = null;
    let nextFree = Infinity;

    Object.entries(this.variantMetafields).forEach(([id, meta]) => {
      const { count: free } = resolveBundleFreeItems(
        meta,
        (window.productData?.variants || []).find((v) => String(v.id) === String(id))
      );
      if (free > currentFreeLimit && free < nextFree) {
        next = id;
        nextFree = free;
      }
    });

    return next;
  }
}

// Usage:
const autoSelector = new AutoVariantSelector({}, window.ColorSelectionStore);

// Later, when metafields are available
if (window.variantMetafields) {
  autoSelector.setVariantMetafields(window.variantMetafields);
} else {
  // Or wait until metafields are set dynamically
  const observer = setInterval(() => {
    if (window.variantMetafields) {
      autoSelector.setVariantMetafields(window.variantMetafields);
      clearInterval(observer);
      // console.log("Metafields loaded ✅");
    }
  }, 100);
}

/* ---- Selection Grid ---- */
class ColorSelectionGrid extends HTMLElement {
  connectedCallback() {
    // Prevent double-init (HMR / re-attach) which can stack grids
    if (this._booted) return;
    this._booted = true;

    // Always start clean — never keep Liquid/SSR children beside JS output
    this.innerHTML = '';
    this.removeAttribute('data-ready');

    const {maxItems,freeItems,optionalItems,requiredOff,optionalOff,defaultVariant} = this.dataset;
    autoSelector.setVariant(defaultVariant);
    const store = window.ColorSelectionStore;

    const variantId = defaultVariant;
    const metafields = (window.variantMetafields && window.variantMetafields[variantId]) || {};
    const productVariant = (window.productData?.variants || []).find(
      (v) => String(v.id) === String(variantId)
    );
    const resolved = resolveBundleFreeItems(
      { free_items: freeItems ?? metafields.free_items },
      productVariant
    );
    const resolvedOff = resolveBundleDiscount(
      { discount_percentage: requiredOff ?? metafields.discount_percentage },
      resolved.count,
      resolved.inferred
    );

    store.set('maxItems', Number(maxItems) || resolved.count || 0);
    store.set('freeItems', resolved.count);
    store.set('optionalItems', optionalItems);
    store.set('requiredOff', resolvedOff);
    store.set('optionalOff', optionalOff);

    this._unsubRender = store.subscribe(() => this.render());
    this._unsubButton = store.subscribe(() => toggleBundleButton());
    this.setAttribute('data-ready', 'true');

    document.addEventListener("variant:change", this._onVariantChange);
  }


  disconnectedCallback() {
    document.removeEventListener("variant:change", this._onVariantChange);
    if (typeof this._unsubRender === 'function') this._unsubRender();
    if (typeof this._unsubButton === 'function') this._unsubButton();
    this._unsubRender = null;
    this._unsubButton = null;
    this._booted = false;
  }

  _onVariantChange = (e) => {
    const store = window.ColorSelectionStore;
    const variant = e.detail.variant;
    const id = variant?.id;
    if(!id) return;
    autoSelector.setVariant(id)
    const metafields = (window.variantMetafields && window.variantMetafields[id]) || {};
    const resolved = resolveBundleFreeItems(metafields, variant);
    const requiredOff = resolveBundleDiscount(metafields, resolved.count, resolved.inferred);
    store.set("freeItems", resolved.count);
    store.set("requiredOff", requiredOff);
    store.trimTo(resolved.count);
    toggleBundleButton(variant);
  }

  render() {
    const store = window.ColorSelectionStore;
    const {requiredOff} = store._state;
    const freeItems = Number(store.get('freeItems'));
    const optionalItems = Number(store.get('optionalItems'));
    const items = store.getItems();

    // Einzelstück / non-bundle variants: hide the design picker
    if(!freeItems) {
      this.innerHTML = '';
      return;
    }

    //Build the grid content
    let gridContent = "";

    // -- Step 1 & 2: Fill freeItems slots ---
    for(let i = 0; i < freeItems; i++){
      if(items[i]){
        //Replace placeholder with actual selected item
        const item = items[i];
        gridContent += `
            <color-switcher-item
              class="color-selection__grid-item required-switcher coladded" 
              data-count="${i+1}" data-total-count="${freeItems}"
              data-type="item"
              data-id="${item.id}"
              data-name="${item.name}"
              data-img="${item.img}"
              data-vendor="${item.vendor}"
              data-price="${item.price}"
              data-compare="${item.compare}"
              data-count=${i + 1}>
            </color-switcher-item>
        `
      }else{
        //Empty placeholder card
        gridContent +=`
            <color-switcher-item
              data-type="placeholder"
              class="color-selection__grid-item required-switcher" 
              data-count="${i+1}" data-total-count="${freeItems}">
            </color-switcher-item>
        `;
      }
    }

    // -- Step 4: Add optional card if needed
    // if(optionalItems > 0){
    //   gridContent +=`
    //     <color-switcher-item
    //       data-type="optional"
    //       class="color-selection__grid-item optional-switcher" 
    //     >
    //     </color-switcher-item>
    //   `;
    // }

    this.innerHTML = `
      <div class="color-selection__container">
        <div class="color-selection__label">         
          <h4 class="color-selection__label_heading">Wähle Deine Designs:</h4>
          <div class="color-selection__label_text">
            <span class="unfilled" style="color: rgb(39, 39, 39);">
              <span class="set-no-color_selected">${items?.length <= freeItems ? items.length : freeItems}</span> von
              <span class="set-no-color">${freeItems}</span> ausgewählt</span>
          </div>
        </div>
        <div class="color-selection__grid  more-colors-grid">
          ${gridContent}
        </div>
      </div>
    `;
  }
}
if (!customElements.get("color-selection-grid")) {
  customElements.define("color-selection-grid", ColorSelectionGrid);
}

/* ---- Grid Item ---- */
class ColorSwitcherItem extends HTMLElement {
  connectedCallback() {
    const store = window.ColorSelectionStore;
    const {requiredOff} = store._state;
    const {type,id, name, img, vendor, price, compare,count} = this.dataset;

    
    this.innerHTML = `
          <color-switcher class="color-selection__image color-selection__item required-switcher color-selection__image--top pi-4 active ${type === 'item' ? 'coladded' : ''}" 
            style="${img ? `background-image: url('${imgUrl(img,'200x')}');` : ''}">
              <span class="discounted_percent">-${requiredOff}%</span>
            <button class="remove_item">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </button>
          </color-switcher>
          <div class="farbe-title">${
            type === "item" ? name :
            type === "placeholder" ? "Design "+count :
            type === "optional" ? "Optional Design" : ""
          }</div>
          
          <div class="farbe-price_wrapper">
            <div class="farbe-price"><span class="money">${price ? w(parseFloat(price),window.theme.currency.moneyFormat) : ''}</span></div>
            ${(typeof compare == 'undefined' || compare == 'undefined') ? '' : 
              `<div class="farbe-compare"><span class="money">${w(parseFloat(compare),window.theme.currency.moneyFormat)}</span></div>`
            }
          </div>
    `;

    // <div class="farbe-vendor">${vendor || ''}</div>

    this.querySelector(".remove_item").addEventListener("click", (e) => {
      e.stopPropagation();
      window.ColorSelectionStore.removeOne(id);
    });

    type !== 'item' && this.addEventListener('click', () => {
      document.querySelector('color-choose-drawer')?.open();
    })
  }
}
customElements.define("color-switcher-item", ColorSwitcherItem);

/* ---- Drawer ---- */
class ColorChooseDrawer extends HTMLElement {

  constructor() {
    super();

    this.overlay = null;
    this.products = [];
    this.cursor = null;
    this.hasNextPage = true;
    this.loading = false;
  }
  connectedCallback() {
    this.products = JSON.parse(this.dataset.products || "[]");
    this.collectionHandle = this.dataset.collection;
    this.overlay = document.querySelector('.drawer-overlay');
    this.overlay.addEventListener('click',this.close.bind(this))
    // this.render();
    this.loadMore()
    window.ColorSelectionStore.subscribe(() => this.updateSlider());
  }

  async loadMore() {
    if(!this.hasNextPage || this.loading) return;
    this.loading = true;

    const query = `
      query($handle: String!, $cursor: String) @inContext(country: ${Shopify?.country || 'DE'}){
        collection(handle: $handle){
          products(first: 40, after: $cursor){
            edges {
              cursor
              node {
                id
                title
                availableForSale
                tags
                images(first: 5) {edges { node { url } } }
                variants(first: 1){
                  edges {
                    node {
                      id
                      price {
                        amount
                        currencyCode
                      }
                      compareAtPrice {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
            pageInfo { hasNextPage }
          }
        }
      }
    `;

    const resp = await fetch('https://getfabulous-de.myshopify.com/api/2024-07/graphql.json',{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '769d8a51c795950e4aaf2de12570bf5b'
      },
      body: JSON.stringify({
        query,
        variables: { handle: this.collectionHandle, cursor: this.cursor },
        extensions: {country: Shopify?.country || 'DE'}
      })
    })

    const json = await resp.json();
    const edges = json.data.collection.products.edges;

    this.cursor = edges.length ? edges[edges.length - 1].cursor : null;
    this.hasNextPage = json.data.collection.products.pageInfo.hasNextPage;
    this.renderMore(edges.map(e => e.node));
    this.loading = false;
  }

  onScroll() {
    if(!this.hasNextPage || this.loading) return;
    const el = this.querySelector('.drawer__content');
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 300;
    if (nearBottom) {
      this.loadMore();
    }
  }


  disconnectedCallback(){
    this.querySelector(".icon-close").removeEventListener("click", () => this.close());
  }

  open() {
    this.classList.add('-active');
    this.overlay.classList.add('active')
  }
  close() { 
    
    this.classList.remove('-active');
    this.overlay.classList.remove('active')
  }

  renderMore(newProducts) {
    const container = this.querySelector('.product-tiles') || this.createContainer();
    
    container.insertAdjacentHTML(
      'beforeend',
      newProducts.map(p => this.template(p)).join('')
    );
  }

  template(p) {
    
    if (!p.tags.includes('bundle_item') || !p.availableForSale) return '';
    // console.log("Product",p)
    const default_variant = p.variants.edges[0].node;
    const imgs = p.images.edges.map((edge)=>edge.node.url).join(',');
    const price = default_variant.price?.amount;
    const compare_at_price = default_variant.compare_at_price?.amount;
    return `
      <drawer-product-item
        class="product-tile-item"
        data-id="${default_variant.id}"
        data-name="${p.title}"
        data-imgs="${imgs}"
        data-price="${price}"
        data-compare="${compare_at_price ? (compare_at_price) : (price)}">
      </drawer-product-item>`;
  }

  createContainer() {
    this.innerHTML = `
      <div class="drawer__header">
        <p>Choose your designs</p>
        <i class="icon icon-close"></i>
      </div>
      <div class="drawer__content">
        <div class="product-tiles"></div>
      </div>
      <selected-slider></selected-slider>
    `;
    this.querySelector('.icon-close').addEventListener('click', () => this.close());
    this.querySelector('.drawer__content').addEventListener('scroll',this.onScroll.bind(this));
    return this.querySelector('.product-tiles');
  }

  // render() {
  //   // console.log("Products",this.products)
  //   this.innerHTML = `
  //     <div class="drawer__header">
  //   <p>Choose your designs</p>
  //   <i class="icon icon-close"></i>
  // </div>
  // <div class="drawer__content ">
  //   <div class="product-tiles">
  //       ${this.products.map(p =>
  //         {
  //           if(p.tags.includes('bundle_item') && p.available){
  //             return `
  //               <drawer-product-item
  //                 class="product-tile-item"
  //                 data-id="${p.id}"
  //                 data-name="${p.title}"
  //                 data-imgs="${p.images}"
  //                 data-vendor="${p.vendor}"
  //                 data-price="${p.price/100}",
  //                 data-compare="${p.compare_at_price ? (p.compare_at_price/100) : (p.price/100)}">
  //               </drawer-product-item>
  //             `;
  //           }else{
  //             return '' 
  //           }
  //         }).join("")}
  //   </div>
  //   </div>

  //   <selected-slider></selected-slider>
  //   `;
  //   this.querySelector(".icon-close").addEventListener("click", () => this.close());


  // }

  updateSlider() {
    this.querySelector("selected-slider")?.render();
  }
}
customElements.define("color-choose-drawer", ColorChooseDrawer);


function formatMoney(amount,currencyCode) {
  if(!amount || !currencyCode) return;
  return new Intl.NumberFormat(Shopify.locale,
    { style: 'currency', currency: currencyCode }
  ).format(amount);
}

function convertPrice(price, rate, buyerCurrency) {
  // price = { amount: "19.95", currency_code: "EUR" }
  const baseAmount = parseFloat(price.amount);

  // convert with your known rate
  const converted = baseAmount * rate;

  // format in buyer’s local currency
  return formatMoney(converted,buyerCurrency)
}

function convertToStoreCurrency(priceInActive) {
  const rate = parseFloat(Shopify.currency.rate);
  // rate = amount of active currency per 1 store-currency unit
  return (priceInActive / rate).toFixed(2); // returns string like "14.59"
}

/* ---- Drawer Product Item ---- */
class DrawerProductItem extends HTMLElement {
  connectedCallback() {
    const store = window.ColorSelectionStore;
    const {id, name, imgs, vendor, price, compare} = this.dataset;
    let images = imgs.split(',');
    let img = imgs.split(',').length > 0 ? imgs.split(',')[0] : null;
    this.innerHTML = `
            <div class="product-item__label-list label-list">
          <span class="label label--custom percentOff" style="">-25%</span>
        </div>
        <div class="added_tag_inner">
          <div class="added_tag_main">
            <div class="quantity-selector">
                <button type="button" class="quantity-selector__button quantity_minus">
                  <span class="visually-hidden"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">Reduce quantity</font></font></span>
                  <svg focusable="false" width="10" height="2" class="icon icon--minus-big product_item_minus" viewBox="0 0 10 2">
                      <path fill="currentColor" d="M0 0h10v2H0z"></path>
                  </svg>
                </button>
                <input type="number" is="input-number" class="quantity-selector__input" inputmode="numeric" name="quantity" autocomplete="off" value="1" step="1" min="1" aria-label="Crowd" readonly="">
                <button type="button" class="quantity-selector__button quantity_plus">
                  <span class="visually-hidden"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">Increase quantity</font></font></span>
                  <svg focusable="false" width="10" height="10" class="icon icon--plus-big product_item_plus" viewBox="0 0 10 10">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6v4h2V6h4V4H6V0H4v4H0v2h4z" fill="currentColor"></path>
                  </svg>
                </button>
            </div>
          </div>
        </div>
        <div class="tile-media tile-media-slider swiper-container" data-next-enabled="true">
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
          ${images.map((img)=>`<div class="product-card__image u-aspect-ratio swiper-slide" style="--aspect-ratio: 1;">
                  
                  <img class="swiper-lazy lazy fade-in" src="${imgUrl(img,'200x')}" alt="Doonails" height="150" width="150" class="tile-media_img_1">
                </div>`).join("")}
          </div>

        </div>
        <div class="product-details">
          
          <p class="title">${name}</p>
        </div>
    `;


    this.addedTagInner = this.querySelector(".added_tag_inner");
    this.input = this.querySelector(".quantity-selector__input");

    const discountedPrice = (price,discount) =>{
        if(discount){
          return price - ((discount*price)/100);
        }else{
          return price;
        }
    }


    // Plus button = add
    this.querySelector(".quantity_plus").addEventListener("click", (e) => {
      e.stopPropagation();
      const {requiredOff} = store._state;
      autoSelector.addItem({ id, name, img, vendor, price:discountedPrice(compare,requiredOff), compare })
    });

    // Minus button = remove one
    this.querySelector(".quantity_minus").addEventListener("click", (e) => {
      e.stopPropagation();
      store.removeOne(id);
    });

    // Keep UI synced
    store.subscribe(() => {
      const qty = store.count(id);
      if (qty > 0) {
        this.addedTagInner.style.display = "block";
        this.input.value = qty;
      } else {
        this.addedTagInner.style.display = "none";
        this.input.value = 0;
      }
    });

    // Initial render
    const initialQty = store.count(id);
    if (initialQty > 0) {
      this.addedTagInner.style.display = "block";
      this.input.value = initialQty;
    } else {
      this.addedTagInner.style.display = "none";
      this.input.value = 0;
    }


    // Host click listener: use capture to catch the click early
    const onHostClick = (ev) => {
      const {requiredOff} = store._state;
      // If click originated inside the quantity selector, ignore
      if (ev.target.closest(".quantity-selector")) return;

      // ensure store exists
      if (!store || typeof store?.add !== "function") {
        console.warn("[DrawerProductItem] ColorSelectionStore not available yet");
        return;
      }

      const payload = {
        id: String(id),
        name,
        img,
        vendor,
        price:discountedPrice(compare,requiredOff),
        compare,
        quantity: parseInt(this.input.value || "1", 10)
      };

      console.log("[DrawerProductItem] adding to store", payload);
      autoSelector.addItem(payload)
    };

    // use capture:true to make it more robust against other listeners that call stopPropagation in bubble phase
    this.addEventListener("click", onHostClick, { capture: true });

    // keep ref if you want to remove later
    this._onHostClick = onHostClick;
  }

  disconnectedCallback() {
    if (this._onHostClick) this.removeEventListener("click", this._onHostClick, { capture: true });
  }
}
customElements.define("drawer-product-item", DrawerProductItem);

/* ---- Slider ---- */
class SelectedSlider extends HTMLElement {

  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.maxItems = window.ColorSelectionStore?.get("maxItems") || 20; // fallback
    this.render();
    window.ColorSelectionStore.subscribe(() => this.render());
  }
  render() {

    const state = window.ColorSelectionStore._state; // full state
    const items = window.ColorSelectionStore.getItems() || [];
    const maxItems = state.maxItems || this.maxItems;
    const placeholderImg = "https://cdn.shopify.com/s/files/1/0367/4233/2475/files/new-item-bg.png?v=1757329451";

    // Build slots (real items first, placeholders after)
    const slots = Array.from({ length: maxItems }).map((_, i) => {
      const item = items[i];
      const img = item ? item.img : placeholderImg;
      const selected = item ? "coladded" : "";
      return `
        <div class="selected_item swiper-slide ${selected}" 
             data-index="${i + 1}" 
             data-max-color="${maxItems}" 
             style="background-image: url('${img}')">
        </div>
      `;
    });

    if(!items || items.length <= 0){
      this.innerHTML = '';
    }

    this.innerHTML = `
      <div class="${items && items.length > 0 && 'active'} color_choose_guarantee_inner">
          <div class="color_selected_inner">
            <div class="color_selected_main">
              <div class="swiper-container color_selected_slider">
                <div class="swiper-wrapper" style="height:40px">
                  ${slots.join("")}
                </div>
              </div>
            </div>
          </div>
      </div>


      <div class="slider">
        ${window.ColorSelectionStore?.items?.map(i => `
          <div class="selected-item" style="background-image:url(${i.img})"></div>
        `).join("")}
      </div>
    `;

    this.initSwiper();
  }

  initSwiper() {
    const container = this.querySelector(".color_selected_slider");

    if (this.swiper) {
      this.swiper.destroy(true, true); // destroy old instance
    }

    if (container) {
      this.swiper = new Swiper(container, {
        direction: "horizontal",
        loop: false,
        preloadImages: false,
        lazy: true
      });
    }
  }
}
customElements.define("selected-slider", SelectedSlider);

function toggleBundleButton(variant = null) {
  const store = window.ColorSelectionStore;
  const {price,compare} = store.getCartPrice();
  const freeItems = Number(store.get('freeItems'));
  const items = store.getItems().length;

  const btn = document.querySelector(".product-bundle-add-to-cart--js");
  if (!btn) return;

  if(freeItems == 0){
    
    if(variant){
      if(variant.compare_at_price){
        btn.innerHTML = `<p>In den Warenkorb |  
        <span style="text-decoration:line-through;">${w(parseFloat(variant.compare_at_price/100),window.theme.currency.moneyFormat)}</span>
        <span>${w(parseFloat(variant.price/100),window.theme.currency.moneyFormat)}</span></p>`;
      }else{
        btn.innerHTML = `<p>In den Warenkorb |
        <span>${w(parseFloat(variant.price/100),window.theme.currency.moneyFormat)}</span></p>`;
      }
    }else{
      btn.innerHTML = `<p>In den Warenkorb</p>`;
    }
  }else if (items >= freeItems && freeItems != 0) {
    btn.innerHTML = `<p>In den Warenkorb | 
    <span style="text-decoration:line-through;">${w(parseFloat(compare),window.theme.currency.moneyFormat)}</span>
    <span>${w(parseFloat(price),window.theme.currency.moneyFormat)}</span></p>`;
  } else {
    btn.innerHTML = `<p>Wähle Dein Design  ${items + 1}</p>`;
  }
}

/* ---- Add To Cart ---- */

$(document).on('click','.product-bundle-add-to-cart--js',async function(e){
  e.preventDefault();
  const $btn = $(this);
  const store = window.ColorSelectionStore;
  const { price } = store.cartPrice;
  const items = store.getItems().length;
  const freeItems = Number(store.get("freeItems"));

  if(freeItems != 0 && items < freeItems){
    document.querySelector('color-choose-drawer')?.open();
    return;
  }
  
  let id = null;
  let elem = $(this).parents(".product-form").find(".product-select-variants");
  if ($(elem).val()) {
    id = $(elem).val();
  }

  
  let quantityInput = $(this).parents(".product-form").find("input[name='quantity']");
  let quantity = $(quantityInput).val();
  if(!quantity) return;

  if(!id) return;

  if(freeItems > 0){
    $btn.addClass('loading').prop('disabled',true);
    const product = await createProduct(price*100);
    if(!product) return;
    const {variant} = product;
    
    setTimeout(()=>{
      store.addToCart(variant.id,quantity);
      $btn.removeClass('loading').prop('disabled', false);
    },800);
    
  }else{
    store.addToCartNormal(id,quantity);
  }
})


const createProduct = async (price) => {
    const url = 'https://msvhn7yzmi.execute-api.eu-central-1.amazonaws.com/dev/api/variant';

    const shop = window.Shopify.shop;
    const schema = window.productInfo;

    try {
      const data = {
          shop: shop,
          title: schema.info.title,
          bundle_title: schema.info.bundle_title,
          tag: schema.tag,
          price: convertToStoreCurrency(price),
          image: schema.info.image,
          weight:schema.info.weight,
          weight_unit:schema.info.weight_unit,
          requires_shipping: schema.info.requires_shipping
      };
      const response = await fetch(url,{
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
      });
      const product = await response.json()
      return product;
    } catch (error) {
      console.log("Error",error);
      return null;
    }

}